var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Widget, WidgetHeader, WidgetBody, WidgetFooter, WidgetTitle, WidgetSpinner } from "../";

import { Chart, ChartTooltip, FormatMetric } from "../";

import Color from 'color';
import _ from "lodash";
import moment from "moment";

import "./AnalyticsReportLive.scss";

var AnalyticsReportLive = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsReportLive, _Component);

    function AnalyticsReportLive() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsReportLive);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            style: {},
            colors: ["white", "rgba(255,255,255,0.25)"],
            loading: true,
            activeUsers: undefined,
            activePages: undefined,
            pageviewsChart: undefined
        }, _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.activeUsersReport !== _this.props.activeUsersReport) {
                _this.getActiveUsers();
                _this.getActivePages();
            }

            if (prevProps.theme !== _this.props.theme || prevProps.backgroundColor !== _this.props.backgroundColor) {
                _this.getColors();
            }

            if (prevProps.pageviewsReport !== _this.props.pageviewsReport) {
                _this.getPageviewsChart();
            }
        }, _this.getColors = function () {
            var _this$props = _this.props,
                backgroundColor = _this$props.backgroundColor,
                theme = _this$props.theme;


            backgroundColor = Color(backgroundColor);

            var color = void 0;

            if (theme) {
                backgroundColor = "white";
                color = theme && theme.primaryColor || "black";
            } else if (backgroundColor.isDark()) {
                color = "white";
            } else {
                color = "black";
            }

            var style = {
                backgroundColor: backgroundColor,
                color: color

                // colors

            };var colors = [];

            if (color === "white") {
                colors = ["white", "rgba(255,255,255,0.25)"];
            } else {
                colors = [color, "rgba(0,0,0,0.125)"];
            }

            _this.setState({
                style: style,
                colors: colors
            });
        }, _this.getActivePages = function () {
            var activeUsersReport = _this.props.activeUsersReport;


            if (!activeUsersReport) {
                return false;
            }

            var query = activeUsersReport.query,
                columnHeaders = activeUsersReport.columnHeaders,
                rows = activeUsersReport.rows;


            var metric = query.metrics[0];

            var keys = columnHeaders.map(function (col, index) {
                return col.name;
            });

            var data = rows.map(function (row, r) {

                var page = {};

                row.map(function (value, index) {
                    page[keys[index]] = value;
                });

                return page;
            });

            var activePages = _.orderBy(data, "rt:activeUsers", 'desc'); // Use Lodash to sort array by 'value'

            _this.setState({
                activePages: activePages
            });
        }, _this.getActiveUsers = function () {
            var activeUsersReport = _this.props.activeUsersReport;


            if (!activeUsersReport) {
                return false;
            }

            var query = activeUsersReport.query,
                totalsForAllResults = activeUsersReport.totalsForAllResults;


            var metric = query.metrics[0];
            var value = totalsForAllResults[metric];

            var activeUsers = {
                label: metric,
                value: value
            };

            _this.setState({
                loading: false,
                activeUsers: activeUsers
            });
        }, _this.getPageviewsChart = function () {
            var pageviewsReport = _this.props.pageviewsReport;


            if (!pageviewsReport) {
                return false;
            }

            var columnHeaders = pageviewsReport.columnHeaders,
                rows = pageviewsReport.rows;


            var keys = columnHeaders.map(function (col, index) {
                return col.name;
            });

            var data = rows.map(function (row, r) {

                var dimension = {
                    id: row[0],
                    value: parseInt(row[1])
                };

                row.map(function (value, index) {
                    dimension[keys[index]] = value;
                });

                return dimension;
            });

            var pageviewsChart = {
                type: "bar",
                data: data,
                keys: ['value'],
                enableGridX: false,
                enableGridY: false,
                margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            };

            _this.setState({
                pageviewsChart: pageviewsChart
            });
        }, _this.renderTooltip = function (props) {
            var data = props.data;


            var minutesAgo = moment().subtract(data['rt:minutesAgo'], "minutes").fromNow();

            return React.createElement(
                ChartTooltip,
                null,
                React.createElement(
                    "h2",
                    { className: "admin-tooltip__title" },
                    minutesAgo
                ),
                React.createElement(
                    "h3",
                    { className: "admin-tooltip__value" },
                    React.createElement(FormatMetric, { name: "rt:activeUsers", type: "INTEGER", value: data.value })
                )
            );

            return React.createElement(
                ChartTooltip,
                null,
                JSON.stringify(data)
            );
        }, _this.renderChart = function () {
            var chartTitle = _this.props.chartTitle;
            var _this$state = _this.state,
                pageviewsChart = _this$state.pageviewsChart,
                colors = _this$state.colors;


            var loading = _this.state.loading || _this.props.loading;

            if (!pageviewsChart || loading) {
                return false;
            }

            return React.createElement(
                "section",
                { className: "chart" },
                React.createElement(Chart, _extends({}, pageviewsChart, { renderTooltip: _this.renderTooltip, colors: colors }))
            );

            return React.createElement(
                "section",
                { className: "chart" },
                React.createElement(
                    "h2",
                    { className: "chart__title" },
                    chartTitle
                ),
                React.createElement(Chart, _extends({}, pageviewsChart, { renderTooltip: _this.renderTooltip, colors: colors }))
            );
        }, _this.renderListItem = function (page, index) {

            return React.createElement(
                "li",
                { className: "list-item", key: index },
                React.createElement(
                    "b",
                    { className: "list-item__label" },
                    page['rt:pagePath']
                ),
                React.createElement(
                    "i",
                    { className: "list-item__value" },
                    page['rt:activeUsers']
                )
            );
        }, _this.renderDetails = function () {
            var listTitle = _this.props.listTitle;
            var activePages = _this.state.activePages;


            var loading = _this.state.loading || _this.props.loading;

            if (!activePages || loading) {
                return false;
            }

            var top5 = activePages.slice(0, 5);

            return React.createElement(
                "section",
                { className: "details" },
                React.createElement(
                    "h2",
                    { className: "list__title" },
                    listTitle
                ),
                React.createElement(
                    "ul",
                    { className: "list" },
                    top5.map(_this.renderListItem)
                )
            );
        }, _this.renderSummary = function () {
            var _this$props2 = _this.props,
                title = _this$props2.title,
                loadingTitle = _this$props2.loadingTitle;
            var _this$state2 = _this.state,
                activeUsers = _this$state2.activeUsers,
                style = _this$state2.style;


            var loading = _this.state.loading || _this.props.loading;

            if (!activeUsers || loading) {

                return React.createElement(
                    "section",
                    { className: "summary" },
                    React.createElement(
                        "h1",
                        { className: "summary__title" },
                        loadingTitle
                    ),
                    React.createElement(WidgetSpinner, { style: style })
                );
            }

            return React.createElement(
                "section",
                { className: "summary" },
                React.createElement(
                    "h1",
                    { className: "summary__title" },
                    title
                ),
                React.createElement(
                    "h2",
                    { className: "summary__value" },
                    activeUsers.value
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsReportLive.prototype.componentDidMount = function componentDidMount() {
        this.getColors();
        this.getPageviewsChart();
        this.getActiveUsers();
        this.getActivePages();
    };

    AnalyticsReportLive.prototype.render = function render() {
        var style = this.state.style;


        return React.createElement(
            Widget,
            _extends({}, this.props, { style: style }),
            React.createElement(
                WidgetHeader,
                null,
                this.renderSummary(),
                this.renderChart()
            ),
            React.createElement(
                WidgetFooter,
                null,
                this.renderDetails()
            )
        );
    };

    return AnalyticsReportLive;
}(Component), _class.defaultProps = {
    backgroundColor: "white",

    reportType: "live",
    widgetType: "analytics-live",
    widgetSize: "1:4",

    loadingTitle: "Live rapport",

    title: "Aktive brukere akkurat nå",
    chartTitle: "Sidevisninger per minutt",
    listTitle: "Mest aktive sider",

    activeUsersReport: undefined,
    pageviewsReport: undefined
}, _temp2);
AnalyticsReportLive.propTypes = process.env.NODE_ENV !== "production" ? {
    title: PropTypes.string,
    chartTitle: PropTypes.string,
    listTitle: PropTypes.string,
    loadingTitle: PropTypes.string,
    loadingDescription: PropTypes.string,
    scope: PropTypes.string
} : {};


export default AnalyticsReportLive;